import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const mcQuestionElement = css`
	.CodeMirror {
		height: auto;
		border: 1px solid ${colors.border};
		border-radius: 4px;
		padding: 6px 12px;
		font-size: 16px;
		font-family: inherit;
		color: ${colors.mainText};
	}

	.choice {
		margin-top: 30px;
		position: relative;

		.choiceGroup {
			flex-wrap: nowrap;
		}

		.input-group-text {
			border-bottom-left-radius: 0;
			border-bottom: none;
			background-color: ${colors.background};
		}

		.react-codemirror2 {
			width: 100%;
		}

		.CodeMirror {

			border-radius: unset;
			border-top-right-radius: 4px;
		}
	}

	.question-text {
		border-bottom-right-radius: unset;
		font-weight: 600;
	}

	.rejoinder {
		display: flex;
		background-color: ${colors.background};
		border: 1px solid #ced4da;
		border-top: none;

		.draggableBlock {
			width: 39px;
			display: flex;
			align-items: center;
			justify-content: center;

			svg {
				width: 15px;
			}
		}

		.CodeMirror {
			font-size: 14px;
			border-radius: unset;
			border: none;
			border-left: 1px solid #ced4da;
		}
	}

	.deleteChoiceIcon {
		position: absolute;
		top: 4px;
		right: 4px;
		color: #ced4da;

		:hover {
			color: ${colors.hoverText};
		}
	}

	.addChoiceButton {
		margin-top: 15px;
		font-size: 14px;
		border: none;

		:hover {
			color: ${colors.mainText};
			border-color: ${colors.border};
			background-color: ${colors.background};
		}

		svg {
			margin-right: 5px;
		}
	}
`;
